import { Actions } from "./Actions";

const defaultSate = {
  infraType: null,
};

const InfraReducer = (state = defaultSate, action) => {
  switch (action.type) {
    case Actions.ON_RESET_STATE:
      return { ...defaultSate };

    case Actions.GET_INFRA_TYPE:
      return { ...state, infraType: action.details };
    default:
      return { ...state };
  }
};

export default InfraReducer;
